import { useEffect, useState } from "react";
import api from "@/lib/api";

// Simple module-level cache so we fetch the institution list only once per session.
let _cache = null;

export function useInstitutions() {
  const [institutions, setInstitutions] = useState(_cache || []);

  useEffect(() => {
    if (_cache) {
      setInstitutions(_cache);
      return;
    }
    api
      .get("/institutions")
      .then((r) => {
        _cache = r.data.map((x) => x.name);
        setInstitutions(_cache);
      })
      .catch(() => {});
  }, []);

  const addInstitution = async (name) => {
    const { data } = await api.post("/institutions", { name });
    _cache = data.map((x) => x.name);
    setInstitutions(_cache);
    return name;
  };

  return { institutions, addInstitution };
}
